export const API_ROUTES = {
	ARTIST: (id) => '/api/artists/' + id,
	ARTWORKS: (id) => '/api/artworks/' + id,
	OWNERS: (id) => '/api/owners/' + id,
	OWNER_IDS: '/api/owners/ids',
	ARTIST_IDS: '/api/artists/ids',
	ARTWORK_IDS: '/api/artworks/ids',
	OWNER_NAMES: '/api/owners/names',
	ARTIST_NAMES: '/api/artists/names',
	ENTITY_IDS: (entityType) => `/api/${entityType}s/ids`,
	ENTITY: (entityType, id) => `/api/${entityType}s/${id}`,
	ENTITY_CREATE: (entityType) => `/api/${entityType}s`,
	ENTITY_UPDATE: (entityType, id) => `/api/${entityType}s/${id}`,
	ENTITY_DELETE: (entityType, id) => `/api/${entityType}s/${id}`,
	FILE_LIST: (entityType, entityId) =>
		`/api/file?entityType=${entityType}&entityId=${entityId}`,
	FILE_UPLOAD: '/api/file/upload',
	FILE_UPDATE: (fileId) => `/api/file/${fileId}`,
	DROP_DOWN_BY_NAME: (name) => `/api/drop_downs/${name}`,
	DROP_DOWN_BY_NAME_UPDATE: (name) => `/api/drop_downs/${name}`,
	ARTWORKS_SEARCH: '/api/artworks/search',
}

export const MERCURE_TOPICS = {
	ARTIST: '/api/artists',
	ARTWORK: '/api/artworks',
	OWNER: '/api/owners',
	ENTITY: (entityType) => `/api/${entityType}s`,
}

export const FULL_API_ROUTES = {
	FILE_DOWNLOAD: (filePath, download = false) =>
		DEFAULT_BASE_URL +
		'api/file/download/' +
		filePath
			.split('/')
			.map((segment) => encodeURIComponent(segment))
			.join('/') +
		(download ? '?download=1' : ''),
}

export const DEFAULT_BASE_URL =
	process.env.REACT_APP_API_BASE_URL || 'https://localhost/'

export const ARTWORK_TECHNIQUE_NAME = 'ARTWORK-TECHNIQUE'

export const SYMFONY_CODES = {
	NOT_BLANK: 'c1051bb4-d103-4f74-8988-acbcafc7fdc3',
	NOT_NULL: 'ad32d13f-c3d4-423b-909a-857b961eb720',
}

export const MESSAGES = {
	ERROR: {
		NOT_ENOUGH_IMAGE_FIELDS:
			'Ein Teil der Dateien konnte nicht hochgeladen werden, da die 10 Plätze belegt sind.',
		NAME_NOT_AVAILABLE: 'Der Name ist schon vorhanden.',
		AUTOMATIC_LOGOUT: 'Sie wurden automatisch ausgeloggt.',
		UPLOAD_LIMIT_EXCEEDED: 'Die hochgeladene Datei ist zu groß (maximal 50MB).',
		UNSUPPORETED_MEDIA_TYPE: 'Der Dateityp wird nicht unterstützt.',
		UNKNOWN_ERROR: 'Ein Unbekannter Fehler ist aufgetreten.',
		FIRSTNAME_REQUIRED: 'Der Vorname darf nicht leer sein.',
		LASTNAME_REQUIRED: 'Der Nachname darf nicht leer sein.',
	},
	ENTITY_DELETED_WHILE_VIEWING:
		'Der Eintrag wurde soeben von einem anderen Benutzer gelöscht. Sie wurden zu einem anderen Eintrag navigiert.',
	UPLOAD_DISABLED_UNTIL_CREATION:
		'Das Hochladen von Bildern ist erst möglich, wenn der Eintrag erstellt wurde.',
	UNSAVED_CHANGES:
		'Sie haben ungespeicherte Änderungen. Wenn sie die Seite jetzt verlassen werden diese verworfen. Sind Sie sicher, dass Sie die Seite verlassen wollen?',
	SUCC_LOGIN: 'Sie wurden erfolgreich eingeloggt',
	SUCC_LOGOUT: 'Sie wurden erfolgreich ausgeloggt',
	DELETE_MASKE_TEXT: {
		OWNER_MASK: 'Besitzer löschen',
		ARTIST_MASK: 'Künstler löschen',
		ARTWORK_MASK: 'Werke löschen',
	},
}

export const HTTP_STATUS = {
	UNAUTHORIZED: 401,
	FORBIDDEN: 403,
	NOT_FOUND: 404,
	CONFLICT: 409,
	CONTENT_TOO_LARGE: 413,
	UNSUPPORETED_MEDIA_TYPE: 415,
	BAD_REQUEST: 400,
	SERVER_ERROR: 500,
}

export const FILE_SIZE_LIMIT = (function () {
	const mb = parseInt(process.env.REACT_APP_FILE_SIZE_LIMIT_MB, 10)
	const valMb = Number.isFinite(mb) && mb > 0 ? mb : 50
	return valMb * 1024 * 1024 // bytes
})()

export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_MAIL

export const HUB_URL = DEFAULT_BASE_URL + '.well-known/mercure'
